import "../assets/css/style.css";
import "./ScorePage.css"
import scoreImg1 from '../assets/images/score_img1.png';
import s1 from '../assets/images/scorepage/1.jpeg';
import s2 from '../assets/images/scorepage/2.jpeg';
import s3 from '../assets/images/scorepage/3.jpeg';
import s4 from '../assets/images/scorepage/4.png';
import s5_1 from '../assets/images/scorepage/5.1.jpg';
import s5_2 from '../assets/images/scorepage/5.2.jpg';
import s6_1 from '../assets/images/scorepage/6.1.jpg';
import s6_2 from '../assets/images/scorepage/6.2.jpg';
import r0_0 from '../assets/images/scorepage/results_0_0.jpg';
import r0_1 from '../assets/images/scorepage/results_0_1.jpg';
import r1 from '../assets/images/scorepage/results_1.png';
import r2 from '../assets/images/scorepage/results_2.png';
import r3 from '../assets/images/scorepage/results_3.png';
import r4 from '../assets/images/scorepage/results_4.png';
import r5 from '../assets/images/scorepage/results_5.png';
import r6 from '../assets/images/scorepage/results_6.png';

function Index2Page() {
  return (
    <div className="container_12">
      <div className="grid_12">
        <div className="grid_12 alpha">
          <div className="box-3">
            <div className="gradient_1">
              <h2>分组成绩</h2>
            </div>
            <div
              className="box-3_pad_3 p_text_body_indent p_text_lineheight"
              style={{
                fontSize: "18px",
                textIndent: "50px"
              }}
            >
{/* 女子WOMEN
              <p className="p_header">女子组小组赛成绩</p>
              <p className="p_subheader">小组A</p>
              <p className="p_white">1 &emsp;同和星来</p>
              <p className="p_white">2 &emsp;万方同和</p>
              <p className="p_white">3 &emsp;澳大利亚群英</p>
              <p className="p_white">4 &emsp;协会全红</p>
              <br />
              <p><span className="p_white">群英</span> vs 全红 21:15 21:8</p>
              <p><span className="p_white">方同</span> vs 星来 15:21 21:14 12:15</p>
              <p><span className="p_white">星来</span> vs 群英 21:17 21:8</p>
              <p><span className="p_white">方同</span> vs 全红 21:5 21:16</p>
              <p>群英 vs <span className="p_white">方同</span> 8:21 17:21</p>
              <p>全红 vs <span className="p_white">星来</span> 13:21 12:21</p>
              <br />
              <p className="p_subheader">小组B</p>
              <p className="p_white">1 &emsp;澳大利亚沙拉</p>
              <p className="p_white">2 &emsp;同和诚全</p>
              <p className="p_white">3 &emsp;北京海百利</p>
              <p className="p_white">* &emsp;TN女队</p>
              <br />
              <p><span className="p_white">海百利</span> vs TN&emsp;15:21 21:14 21:14</p>
              <p><span className="p_white">沙拉</span> vs 诚全 &emsp;21:14 21:10</p>
              <p><span className="p_white">诚全</span> vs 海百利 21:16 21:19</p>
              <p><span className="p_white">沙拉</span> vs TN&emsp;&emsp;21:9 21:8</p>
              <p>海百利 vs <span className="p_white">沙拉</span> 15:21 13:21</p>
              <p>TN vs <span className="p_white">诚全</span>&emsp;&emsp;18:21 18:21</p>
              <br />

              <p className="p_header">女子组半决赛成绩</p>
              <p className="p_highlight">(入决赛) 同和星来</p>
              <p className="p_highlight">(入决赛) 澳大利亚沙拉</p>
              <br />
              <p><span className="p_white">星来</span> vs 诚全 &emsp;18:21 21:14 15:2</p>
              <p><span className="p_white">沙拉</span> vs 方同 &emsp;21:14 21:8</p>
              <p><span className="p_white">群英</span> vs TN&emsp;&emsp;21:18 21:19</p>
              <p><span className="p_white">海百利</span> vs 全红 21:11 21:11</p>
              <br />

              <p className="p_header">女子组3-8名决赛</p>
              <p className="p_highlight">3. 万方同和</p>
              <p className="p_highlight">4. 同和诚全</p>
              <p className="p_highlight">5. 北京海百利</p>
              <p className="p_highlight">6. 澳大利亚群英</p>
              <p className="p_highlight">7. 协会全红</p>
              <p className="p_highlight">*  TN女队</p>
              <br />
              <p>诚全 vs <span className="p_white">方同</span> &emsp;21:17 18:21 8:15</p>
              <p>群英 vs <span className="p_white">海百利</span> 19:21 19:21</p>
              <p><span className="p_white">TN</span> vs 全红&emsp;&emsp;21:18 21:16</p>
              <br />

男子MEN
              <p className="p_header">男子组小组赛成绩</p>
              <p className="p_subheader">小组A</p>
              

              <p className="p_white">1 &emsp;万方精英</p>
              <p className="p_white">2 &emsp;同和和风</p>
              <p className="p_white">3 &emsp;协会联盟</p>
              <p className="p_white">4 &emsp;同和取经</p>
              <br />
              <p><span className="p_white">精英</span> vs 联盟 21:11 21:14</p>
              <p>取经 vs <span className="p_white">和风</span> 21:18 17:21 11:15</p>
              <p>和风 vs <span className="p_white">精英</span> 11:21 14:21</p>
              <p>取经 vs <span className="p_white">联盟</span> 20:22 21:19 12:15</p>
              <p><span className="p_white">精英</span> vs 取经 21:14 21:6</p>
              <p>联盟 vs <span className="p_white">和风</span> 12:21 14:21</p>
              <br />
              <p className="p_subheader">小组B</p>


              <p className="p_white">1 &emsp;澳大利亚群英</p>
              <p className="p_white">2 &emsp;协会英雄</p>
              <p className="p_white">3 &emsp;万方元老</p>
              <p className="p_white">* &emsp;TN男队</p>
              <br />
              <p><span className="p_white">群英</span> vs TN&emsp;22:20 21:13</p>
              <p>元老 vs <span className="p_white">英雄</span> 15:21 11:21</p>
              <p>英雄 vs <span className="p_white">群英</span> 13:21 11:21</p>
              <p><span className="p_white">元老</span> vs TN&emsp;21:17 17:21 15:6</p>
              <p><span className="p_white">群英</span> vs 元老 21:17 21:8</p>
              <p><span className="p_white">TN</span> vs 英雄&emsp;21:14 16:21 15:8</p>
              <br />

              <p className="p_header">男子组半决赛成绩</p>
              <p className="p_highlight">(入决赛) 万方精英</p>
              <p className="p_highlight">(入决赛) 澳大利亚群英</p>
              <br />
              <p><span className="p_white">精英</span> vs 英雄 21:16 21:19</p>
              <p><span className="p_white">群英</span> vs 和风 21:14 21:10</p>
              <p>联盟 vs <span className="p_white">TN</span>&emsp;16:21 19:21</p>
              <p>元老 vs <span className="p_white">取经</span> 8:21 21:19 6:15</p>
              <br />

              <p className="p_header">男子组3-8名决赛</p>
              <p className="p_highlight">3. 同和和风</p>
              <p className="p_highlight">4. 协会英雄</p>
              <p className="p_highlight">5. 同和取经</p>
              <p className="p_highlight">6. 协会联盟</p>
              <p className="p_highlight">7. 万方元老</p>
              <p className="p_highlight">*  TN男队</p>
              <br />
              <p>英雄 vs <span className="p_white">和风</span> 21:16 18:21 11:15</p>
              <p>联盟 vs <span className="p_white">取经</span> 12:21 18:21</p>
              <br /> */}
          
              <p></p>

              <img src={r0_0}  />
              <img src={r0_1}  />
              <img src={r1}  />
              <img src={r2}  />
              <img src={r3}  />
              <img src={r4}  />
              <img src={r5}  />
              <img src={r6}  />

              <p className="p_text_header">
              参赛队伍
              </p>
              <p className="p_text_header_white">
              悉尼站分组与比赛次序: 
              </p>
              <img src={s1} style={{marginTop: "20px", width: "100%"}} className="sc_pos_xs sc_pos_sm sc_pos_md sc_pos_lg sc_ml_xl sc_mw_xl" />
              <img src={s2} style={{marginTop: "20px"}} />
              <img src={s3}  />
              <br />

              <p className="p_text_header_white"  style={{marginTop: "20px"}} >
              奥克兰站分组与比赛次序: 
              </p>
              <img src={s4} style={{marginTop: "20px"}} />
              <img src={s5_1} />
              <img src={s5_2} />
              <img src={s6_1} />
              <img src={s6_2} />
              <br />

              <p className="p_text_header">
              对阵代码表
              </p>

<img src={scoreImg1} alt="" />

              {/* <p className="p_text_header">
                <b>分组与成绩</b>: 待抽签和比赛结束后登记
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index2Page;

